import axios from "axios";
import {
    GetMyTransportBookingsDto,
    PublicTransportBookingReadDto,
    UpdateMyTransportBookingDto,
} from "../types/transportPublicTypes";

const apiUrl = process.env.REACT_APP_API_URL as string;

export async function getMyTransportBookings(
    eventId: number,
    dto: GetMyTransportBookingsDto
) {
    const res = await axios.post<PublicTransportBookingReadDto[]>(
        `${apiUrl}/api/events/${eventId}/transport/my-bookings`,
        dto
    );
    return res.data;
}

export async function updateMyTransportBooking(
    eventId: number,
    requestId: number,
    dto: UpdateMyTransportBookingDto
) {
    const res = await axios.patch(
        `${apiUrl}/api/events/${eventId}/transport/my-bookings/${requestId}`,
        dto
    );
    return res.data;
}